<template>
  <div style="position: relative;">
    <el-row>
      <el-col :span="24">
        <el-table ref="specialistHis" :data="hisTab.SpecialistHis.impl.dataList" :size="defaultFormItemSize" @sort-change="hisTab.SpecialistHis.impl.onSortChange"
                  header-cell-class-name="table-header-gray"
                  highlight-current-row @current-change="hisTab.SpecialistHis.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="hisTab.SpecialistHis.impl.getTableIndex" />
          <el-table-column label="专家名称" prop="specialistName">
          </el-table-column>
          <el-table-column label="服务对象" prop="serviceObjectName">
          </el-table-column>
          <el-table-column label="服务地区" prop="serviceAreaIdDictMap.name">
          </el-table-column>
          <el-table-column label="服务对象联系人" prop="contactsUser">
          </el-table-column>
          <el-table-column label="联系人电话" prop="contactsUserTel">
          </el-table-column>
          <el-table-column label="服务期" prop="signYear">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.signYear, 'year')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button @click.stop="showFlow(scope.row)" type="text" :size="defaultFormItemSize"
                         >
                查看流程
              </el-button>
            </template>
          </el-table-column>
        </el-table>

      </el-col>
    </el-row>

    <el-dialog class="comment-dialog" title="审批记录" :visible.sync="dialogVisible" :append-to-body="true">
      <el-row>
        <el-table :data="taskCommentList" :size="defaultFormItemSize" border header-cell-class-name="table-header-gray" height="500px">
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" />
          <el-table-column label="执行人" prop="createUsername" width="150px" />
          <el-table-column label="操作" width="150px">
            <template slot-scope="scope">
              <el-tag :size="defaultFormItemSize" :type="getOperationTagType(scope.row.approvalType)" effect="dark">{{SysFlowTaskOperationType.getValue(scope.row.approvalType)}}</el-tag>
              <el-tag v-if="scope.row.delegateAssignee != null" :size="defaultFormItemSize" type="success" effect="plain" style="margin-left: 10px;">{{scope.row.delegateAssignee}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="审批意见">
            <template slot-scope="scope">
              <span>{{scope.row.taskComment ? scope.row.taskComment : ''}}</span>
            </template>
          </el-table-column>
          <el-table-column label="处理时间" prop="createTime" width="160px" />
        </el-table>
      </el-row>
    </el-dialog>

  </div>
</template>

<script>
import { TableWidget } from '@/utils/widget.js';
import { SpecialistHisController, FlowOperationController} from '@/api';
import { findItemFromList } from '@/utils';
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';

export default {
  name: 'SpecialistHis',
  props: {
    specialistId: null
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],

  data () {
    return {
      hisTab: {
        formFilter: {
        },
        formFilterCopy: {
        },
        SpecialistHis: {
          impl: new TableWidget(this.loadSpecialistHisWidgetData, this.loadSpecialistHisVerify, true, true, 'createTime', 1)
        },
        isInit: false
      },
      taskCommentList: [],
      dialogVisible: false
    }
  },
  methods: {
    /**
     * 专家对接历史数据获取函数，返回Promise
     */
    loadSpecialistHisWidgetData (params) {
      if (params == null) params = {};
      // let _specialistId = this.id;
      // if (_specialistId === undefined) {
      //   _specialistId = -1;
      // }
      params = {
        ...params,
        specialistHisDtoFilter: {
          specialistId: this.specialistId,
          auditStatus: '1'
        }
      }
      return new Promise((resolve, reject) => {
        SpecialistHisController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.hisTab.SpecialistHis.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.hisTab.SpecialistHis.impl.currentRow.id, 'id');
              this.$refs.specialistHis.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 专家对接历史数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSpecialistHisVerify () {
      return true;
    },
    /**
     * 更新服务历史
     */
    refreshHisTab (reloadData = false) {
      if (reloadData) {
        this.hisTab.SpecialistHis.impl.refreshTable(true, 1);
      } else {
        this.hisTab.SpecialistHis.impl.refreshTable();
      }
      if (!this.hisTab.isInit) {
        // 初始化下拉数据
      }
      this.hisTab.isInit = true;
    },
    getOperationTagType (type) {
      switch (type) {
        case this.SysFlowTaskOperationType.AGREE:
        case this.SysFlowTaskOperationType.MULTI_AGREE:
          return 'success';
        case this.SysFlowTaskOperationType.REFUSE:
        case this.SysFlowTaskOperationType.PARALLEL_REFUSE:
        case this.SysFlowTaskOperationType.MULTI_REFUSE:
          return 'warning';
        case this.SysFlowTaskOperationType.STOP:
          return 'danger'
        default:
          return 'primary';
      }
    },
    showFlow (row) {
      let params = {
        processInstanceId: row.processInstanceId
      }
      FlowOperationController.listFlowTaskComment(this, params).then(res => {
        // console.log(JSON.stringify(res))
        this.taskCommentList = res.data
        this.dialogVisible = true
      })
    },
    formInit () {
      this.refreshHisTab();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>

<style scoped>

</style>
